import { atom } from 'jotai'
import { Language } from './../main/Language';

export const _bootstrap = atom({
  siteid      : null,
  sitename    : null,
  favicon     : null,
  type        : null,
  projectids  : null,
  projects    : null,
  projectnames: [],
  cdn         : null,
  routes      : null,
  startpage   : null,
  dropdown    : [],
  openhouse   : null,
  moveinprice : null,
  languages    : []
})